import { useAiCredits } from './use-ai-credits'

/**
 * The subtle metered-credits line under the composer — shown only when the
 * user has a metered AI-answer budget.
 */
export function CompanionCreditsLine() {
  const creditsRemaining = useAiCredits()
  if (creditsRemaining === null) return null
  return (
    <p
      className="pb-1.5 text-center text-[10px] text-muted-foreground/60"
      title={`${creditsRemaining} AI credits remaining`}
    >
      {creditsRemaining} credits remaining
    </p>
  )
}
